import { CYLINDER } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyProperties } from './base';

export class Cylinder extends BaseObject {
  constructor() {
    super(
      new THREE.CylinderGeometry(
        CYLINDER.RADIUS_TOP,
        CYLINDER.RADIUS_BOTTOM,
        CYLINDER.HEIGHT,
        CYLINDER.RADIAL_SEGMENTS
      ),
      new THREE.MeshStandardMaterial({ color: CYLINDER.COLOR })
    );

    this.radiusTop = CYLINDER.RADIUS_TOP;
    this.radiusBottom = CYLINDER.RADIUS_BOTTOM;
    this.height = CYLINDER.HEIGHT;
    this.radialSegments = CYLINDER.RADIAL_SEGMENTS;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.CylinderGeometry(this.radiusTop, this.radiusBottom, this.height, this.radialSegments);
      this.getOutline();
    };

    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      let needsUpdate = false;

      if ('radiusTop' in properties && properties.radiusTop !== this.radiusTop) {
        this.userData.data.radiusTop = properties.radiusTop;
        this.radiusTop = properties.radiusTop;
        needsUpdate = true;
      }
      if ('radiusBottom' in properties && properties.radiusBottom !== this.radiusBottom) {
        this.userData.data.radiusBottom = properties.radiusBottom;
        this.radiusBottom = properties.radiusBottom;
        needsUpdate = true;
      }
      if ('height' in properties && properties.height !== this.height) {
        this.userData.data.height = properties.height;
        this.height = properties.height;
        needsUpdate = true;
      }
      if ('radialSegments' in properties && properties.radialSegments !== this.radialSegments) {
        this.userData.data.radialSegments = properties.radialSegments;
        this.radialSegments = properties.radialSegments;
        needsUpdate = true;
      }

      if (needsUpdate) this.updateGeometry();
    };
  }
}
